import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'naming-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🔖 Naming your Components</h1>
            <p class='section-text' tabindex='0'>
                The first step to creating your components is to name them. Naming is
                required because Mosaic uses the Custom Elements API. Mosaic uses the
                same naming convention of the Custom Elements API, requiring a
                hyphenated name to use as an HTML tag. Something like this would not
                work since it is not hyphenated:
            </p>
            <b style='color:crimson'>
                <ion-icon name="close"></ion-icon>
                &nbsp;Bad: The name is not hyphenated.
            </b>
            <code-segment type='JS'>
                new Mosaic({
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;name: 'MyComponent'
                <br>
                })
            </code-segment>
            <p class='section-text' tabindex='0'>
                This naming example, however, will work:
            </p>
            <b style='color:mediumseagreen'>
                <ion-icon name="checkmark"></ion-icon>
                &nbsp;Good: There is at least one hyphen in the name.
            </b>
            <code-segment type='JS'>
                new Mosaic({
                <br>
                &nbsp;&nbsp;&nbsp;&nbsp;name: 'my-component'
                <br>
                })
            </code-segment>
            
            <p class='section-text' tabindex='0'>
                Once you name your component, you can then use it as a regular
                HTML tag like so:
            </p>
            <code-segment type='HTML'>
                &lt;my-component&gt;&lt;/my-component&gt;
            </code-segment>

            
            <br>
            <p class='section-text' tabindex='0' style="text-align: center;">
                Next we will move onto the topic of adding your component to
                the DOM through the <b>element</b> option.
            </p>

            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/initialization')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Initialization
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/element')}'>
                    Element
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});